export * from './provider';
export * from './figs-font';
//# sourceMappingURL=index.js.map